var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScannerWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3047_6638)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6484 56H53.152C57.4984 56 60.2077 51.2868 58.0346 47.5331L36.7828 10.8152C34.6096 7.06159 29.1908 7.06159 27.0177 10.8152L5.76589 47.5331C3.59273 51.2868 6.30212 56 10.6484 56ZM31.8999 36.2441C30.3477 36.2441 29.0776 34.974 29.0776 33.4218V27.7772C29.0776 26.225 30.3477 24.9549 31.8999 24.9549C33.4522 24.9549 34.7222 26.225 34.7222 27.7772V33.4218C34.7222 34.974 33.4522 36.2441 31.8999 36.2441ZM29.0776 47.5332H34.7222V41.8886H29.0776V47.5332Z",
    fill: "#A12885"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3047_6638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScannerWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scanner-warning.3e5c99a9d6643b7a9a913b417f211738.svg";